import React, { PropTypes } from 'react'
import { Control } from 'react-redux-form/immutable'
import Select from 'react-select'

import errBlock from 'components/ErrBlock'

const InputSelect = ({ model, label, options, required, clearable, placeholder, ...props }) => (
  <div>
    <label htmlFor={label}>{label} {required && <span className="req">*</span>}</label>
    <Control
      model={model}
      component={Select}
      controlProps={{
        options,
        clearable: clearable,
        placeholder: placeholder,
        simpleValue: true,
      }}
      {...props}
    />
    {errBlock(model)}
  </div>
)

InputSelect.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
}

export default InputSelect



// WEBPACK FOOTER //
// ./src/components/InputSelect/index.js